var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { asThemeConsumer } from "../../../../theme/Theme";
import { TextArea } from "../../05-atoms/TextArea";
import { fieldValidationIcon, fieldValidationMessage } from "./Field.utils";
import { FormGroup } from "./Group";
/**
 *
 * @param props
 */
var FormTextAreaComp = function (props) { return (React.createElement(FormGroup, __assign({}, props),
    React.createElement(TextArea, { style: props.style, placeholder: props.placeholder, value: props.value, onChange: props.onChange, disabled: props.disabled, required: props.required, max: props.max, asSummary: props.asSummary, raw: props.raw }),
    (fieldValidationMessage(props) || fieldValidationIcon(props)) &&
        (React.createElement("div", { className: "scl-o-form__info" },
            React.createElement("div", { className: "scl-o-form__info-text" }, fieldValidationMessage(props)),
            React.createElement("div", { className: "scl-o-form__info-icon" }, fieldValidationIcon(props)))))); };
/**
 *
 */
export var FormTextArea = asThemeConsumer(FormTextAreaComp);
